// import { unusedValueExportToPlacateAjd } from "@angular/core/src/render3/interfaces/query";
import { BaseEntity } from "yt-ng-framework";

export class KomitentUgovorStavka extends BaseEntity{
    constructor(){
        super();
    }

    KomitentUgovorID: number = null;
    // UgovorenaVrednost: number = null;
    UgovorenaVrednostValutaId: number = null;
    UgovorenaCena: number = null;
    UgovorenaKolicina: number = null;
    UgovorenaJedinicaMereId: number = null;
    CenaDodatnogPosla: number = null;
    CenaDodatnogPoslaValutaId: number = null;
    Opis: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentUgovorID = input.KomitentUgovorID;
        // this.UgovorenaVrednost = input.UgovorenaVrednost;
        this.UgovorenaVrednostValutaId = input.UgovorenaVrednostValutaId;
        this.UgovorenaCena = input.UgovorenaCena;
        this.UgovorenaKolicina = input.UgovorenaKolicina;
        this.UgovorenaJedinicaMereId = input.UgovorenaJedinicaMereId;
        this.CenaDodatnogPosla = input.CenaDodatnogPosla;
        this.CenaDodatnogPoslaValutaId = input.CenaDodatnogPoslaValutaId;
        this.Opis = input.Opis;
        return this;
    }

    Serialize(input: KomitentUgovorStavka) {
        return input;
    }

}